
import { defineComponent, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import SearchPatient from '@/widgets/WReportCreation/components/SearchPatient.vue'
import PatientCreationForm from '@/widgets/WReportCreation/components/PatientCreationForm.vue'
import { REPORT_CREATION_MODE } from '@/widgets/WReportCreation/constants/reportCreation'
import { useReportCreation } from '@/widgets/WReportCreation/composables/useReportCreation'

export default defineComponent({
  name: 'ChoiceCreationMode',

  components: {
    PatientCreationForm,
    SearchPatient,
  },

  setup() {
    const route = useRoute()
    const { reportCreationMode } = useReportCreation()

    const setDefaultCreationMode = async (): Promise<void> => {
      const patientId = route.params.patientId

      if (patientId && patientId !== 'null-patient') {
        reportCreationMode.value = REPORT_CREATION_MODE.patientExists
      }
    }

    onMounted((): void => {
      setDefaultCreationMode()
    })

    return {
      REPORT_CREATION_MODE,
      reportCreationMode,
    }
  },
})
